import React from 'react'
import { Card, Drawer, Form, Icon, notification, Button, Tooltip, Input, Row, Col } from 'antd'
import _ from 'lodash'
import { connect } from 'react-redux'
import TextArea from 'antd/lib/input/TextArea'
import Request from '../../request'

class WithdrawStudentRequestFinalStage extends React.Component {
    state = {
        visible: true,
        withdrawFinanceNote: '',
        loading: false,
    }

    onClose = () => {
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    doSubmitWithdrawRequest = async (e) => {
        const { withdrawFinalStageNote, withdrawRequstStatus } = this.state;
        const { recordId, formAction, records } = this.props;

        let multipleData = [];
        let invoiceData = null;

        if (!recordId && records && records.length > 0) {
            _.each(records, (recordId) => {
                let nextInvoiceGenerationDates = recordId.nextInvoiceGenerationDates
                    ? recordId.nextInvoiceGenerationDates
                    : [];
                let foundInvoice = _.find(nextInvoiceGenerationDates, function (item) {
                    return item.withdrawRequest === true;
                });
                let invoiceGeneratedRecordId = null;

                if (foundInvoice && foundInvoice._id) {
                    if (typeof foundInvoice._id === 'object' && foundInvoice._id.$oid) {
                        invoiceGeneratedRecordId = foundInvoice._id.$oid;
                    } else {
                        invoiceGeneratedRecordId = foundInvoice._id;
                    }
                }
                let data = {
                    recordId: recordId._id,
                    withdrawFinalStageNote: withdrawFinalStageNote,
                    withdrawRequstStatus: withdrawRequstStatus,
                    invoiceGeneratedRecordId: invoiceGeneratedRecordId
                }
                multipleData.push(data);
            })
        } else {
            let nextInvoiceGenerationDates = recordId.nextInvoiceGenerationDates
                ? recordId.nextInvoiceGenerationDates
                : [];

            let foundInvoice = _.find(nextInvoiceGenerationDates, function (item) {
                return item.withdrawRequest === true;
            });


            let invoiceGeneratedRecordId = null;

            if (foundInvoice && foundInvoice._id) {
                if (typeof foundInvoice._id === 'object' && foundInvoice._id.$oid) {
                    invoiceGeneratedRecordId = foundInvoice._id.$oid;
                } else {
                    invoiceGeneratedRecordId = foundInvoice._id;
                }
            }

            invoiceData = {
                recordId: recordId._id,
                withdrawFinalStageNote: withdrawFinalStageNote,
                withdrawRequstStatus: withdrawRequstStatus,
                invoiceGeneratedRecordId: invoiceGeneratedRecordId
            }
        }

        let data = multipleData && multipleData.length > 0 ? multipleData : invoiceData;

        this.setState({ loading: true });
        let response = await Request.withdrawStudentFinalUpdate(data);
        this.setState({ loading: false });
        if (response.success) {
            notification.success({
                message: response.msg
            })
        } else {
            notification.error({
                message: response.msg
            })
        }
        this.onClose();

        // this.props.onSelect({withdrawFinalStageNote, withdrawRequstStatus, recordId, formAction});
    }

    render() {
        const { enableBTN, recordId, withdrawRequstStatus } = this.props;

        return (
            <Drawer
                title={
                    <div>
                        {'Management Note'} {' '}
                        <a onClick={this.onClose} style={{ float: 'right', color: 'black' }}>
                            <Icon type={'close'} />
                        </a>
                    </div>
                }
                placement="right"
                closable={false}
                onClose={this.onClose}
                width={1000}
                visible={this.state.visible}>
                <Card>
                    <Row>
                        <Col span={24}>
                            <label>Status</label>
                            <select name='withdrawRequstStatus' style={{ 'maxWidth': '400px', 'marginBottom': '10px' }} className='form-control' onChange={(e) => { this.setState({ withdrawRequstStatus: e.target.value }) }}>
                                <option value="">Choose Status</option>
                                <option value="Approve">Approve</option>
                                <option value="Disapprove">Disapprove</option>
                                <option value="Waiting">Waiting</option>
                            </select>
                        </Col>
                        <Col span={24}>
                            <TextArea
                                style={{ 'maxWidth': '400px', 'minHeight': '100px', 'marginBottom': '10px' }}
                                name="withdrawFinalStageNote"
                                placeholder="Note"
                                onChange={(e) => { this.setState({ withdrawFinalStageNote: e.target.value }) }}
                            />
                        </Col>
                    </Row>
                    <br />
                    <Button
                        type="primary"
                        disabled={enableBTN}
                        loading={this.state.loading}
                        onClick={() => this.doSubmitWithdrawRequest()}> Submit
                    </Button>
                </Card>
            </Drawer>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WithdrawStudentRequestFinalStage)